module.exports = __webpack_public_path__ + "static/media/ad-90-day.1d39f812.png";